import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AuthEndpoint } from "../api";

const authApi = new AuthEndpoint();

export const useAuth = create(
    persist(
        (set) => ({
            currentUser: null,
            isAuthenticated: false,
            loading: true,

            setCurrentUser: (userData) => {
                set({
                    currentUser: userData,
                    isAuthenticated: true,
                    loading: false,
                });
            },

            logout: async () => {
                await authApi.logout();
                set({
                    currentUser: null,
                    isAuthenticated: false,
                });
            },
        }),
        {
            name: "auth-storage", // key di localStorage
            partialize: (state) => ({
                currentUser: state.currentUser,
                isAuthenticated: state.isAuthenticated,
            }),
        }
    )
);
